module.exports = __webpack_public_path__ + "media/images/smart_phone/chara_gifu-c018d687a563b31073f74afe46ea0218.png";